<template>
  <div>
    <v-layout row wrap>
      <v-flex md3>
        <p class="headline mt-2">
          Pagos
        </p>
      </v-flex>
      <v-flex md2 mb-3>
        <v-select
          :items="dateTypes"
          v-model="filters.type"
          solo
          color="grey"
        ></v-select>
      </v-flex>
      <v-flex md3 mb-3 pl-3>
        <v-menu
          ref="toPicker"
          :close-on-content-click="true"
          :nudge-right="40"
          :return-value.sync="filters.date"
          transition="scale-transition"
          min-width="290px"
          lazy
          offset-y
          full-width>
          <v-text-field
            slot="activator"
            :value="formatDate(filters.date, filters.type === 'month' ? 'YYYY-MM' : 'YYYY-MM-DD', filters.type === 'month' ? 'MM/YYYY' : 'DD/MM/YYYY')"
            class="k-orange-linear-text"
            prepend-icon="event"
            readonly
            solo>
          </v-text-field>
          <v-date-picker
            v-model="filters.date"
            @input="$refs.toPicker.save(filters.date)"
            locale="es"
            :type="filters.type"
            color="k-orange-linear">
          </v-date-picker>
        </v-menu>
      </v-flex>
      <v-flex md2 mb-3 pl-3>
        <v-btn block :class="{'h-100 ma-0':true, 'white':!filterActive, 'k-orange-linear':filterActive}" @click="filter()">
          <v-icon>filter_list</v-icon>
          Filtrar
        </v-btn>
      </v-flex>
      <v-flex md2 mb-3 pl-3>
        <v-btn block class="k-orange-linear h-100 ma-0" @click="generateReport"> 
          <v-icon small class="pl-2">fas fa-download</v-icon>
        </v-btn>
      </v-flex>
    </v-layout>
    <v-layout row wrap pa-0 ma-0 justify-end>
      <p class="caption" v-if="date">
          Ultima actualización {{ date }}
        </p>
    </v-layout>
    <v-layout row>
      <v-flex md3 class="white elevation-2 mr-2 pb-2">
        <v-list>
          <v-subheader class="f1-3em k-orange-linear">
            Total
          </v-subheader>
          <v-list-tile class="pt-4">
            <v-layout row wrap>
              <v-flex md12 class="f1-1em">
                Numero
              </v-flex>
              <v-flex md12 class="f1-2em k-grey-text">
                {{totalNotifications > 0 ? new Intl.NumberFormat('es-VE').format(totalNotifications) : '0'}}
              </v-flex>
            </v-layout>
          </v-list-tile>
          <v-list-tile class="pt-4">
            <v-layout row wrap>
              <v-flex md12 class="f1-1em">
                Monto
              </v-flex>
              <v-flex md12 class="f1-2em">
                {{totalAmount > 0 ? `$ ${new Intl.NumberFormat('es-VE').format(totalAmount)}` : '0'}}
              </v-flex>
            </v-layout>
          </v-list-tile>
        </v-list>
      </v-flex>
      <v-flex md9 class="white elevation-2 ml-2 py-2 pl-2 pr-4">
        <div id="payment_chart"></div>
      </v-flex>
    </v-layout>
    <sidebar title="Filtrar" :bus="sidebarBus" :delete-filters-button="true">
      <template slot="content">
        <v-layout row wrap>
          <v-flex md6 pl-4>
            <v-select
              :items="dueDays"
              v-model="due_day"
              color="grey">
            </v-select>
          </v-flex>
          <v-flex md6 pl-4>
            <v-select
              v-model="tranche"
              :items="trMorasList"
              color="grey">
            </v-select>
          </v-flex>
          <v-flex md6 pl-4>
            <v-select
              v-model="portfolio_type"
              :items="pursesList"
              color="grey">
            </v-select>
          </v-flex>
          <v-flex md6 pl-4>
            <v-select
              v-model="agency"
              :items="agencies"
              color="grey">
            </v-select>
          </v-flex>
        </v-layout>
      </template>
    </sidebar>
  </div>
</template>

<script>
import moment from 'moment';
import EventBus from '@/event-bus';
import formatDateMixin from '@/mixins/formatDate';
import ctBarLabelsMixin from '@/mixins/ctBarLabels';
import sidebar from '@/components/global/Sidebar';
import reportsListMixin from '@/mixins/reportsList';

const qs = require('qs');

export default {
  mixins: [
    ctBarLabelsMixin,
    formatDateMixin,
    reportsListMixin,
  ],
  components: {
    sidebar,
  },
  data() {
    return {
      date: null,
      seriesChart: [],
      labels: [],
      series: [],
      totalAmount: 0,
      totalNotifications: 0,
      filters: {
        type: 'date',
        date: moment().format('YYYY-MM-DD'),
        portfolio_type: '',
        tranche: '',
        due_day: '',
        agency: '',
      },
      portfolio_type: '',
      tranche: '',
      agency: '',
      due_day: '',
      filterActive: false,
      sidebarBus: {
        open: 'openPaymentReportSidebar',
        close: 'closePaymentReportSidebar',
        apply: 'applyPaymentReportSidebarFilters',
        unapply: 'unapplyPaymentReportSidebarFilters',
      },
      dateTypes: [
        {
          text: 'Mensual',
          value: 'month',
        },
        {
          text: 'Diarios',
          value: 'date',
        },
      ],
      pursesList: [
        {
          text: 'Carteras',
          value: '',
        },
      ],
      dueDays: [
        {
          text: 'Vencimientos',
          value: '',
        },
      ],
      agencies: [
        {
          text: 'Agencias',
          value: '',
        },
      ],
    };
  },
  mounted() {
    this.axios.get('daily_payments/time').then((response) => {
      this.date = moment.utc(response.data.date).local().format('DD/MM/YYYY hh:mm a');
    });
  },
  created() {
    EventBus.$on(this.sidebarBus.apply, () => {
      this.filters.tranche = this.tranche;
      this.filters.portfolio_type = this.portfolio_type;
      this.filters.due_day = this.due_day;
      this.filters.agency = this.agency;
      this.filterActive = true;
      EventBus.$emit(this.sidebarBus.close);
    });
    EventBus.$on(this.sidebarBus.unapply, () => {
      this.filters.tranche = '';
      this.filters.portfolio_type = '';
      this.filters.due_day = '';
      this.filters.agency = '';
      this.tranche = '';
      this.agency = '';
      this.portfolio_type = '';
      this.due_day = moment().format('d');
      this.filterActive = false;
      EventBus.$emit(this.sidebarBus.close);
    });
    EventBus.$on(this.sidebarBus.open, () => {
      this.getDueDays();
      this.getPursesList();
      this.getAgencies();
    });
    this.getReport();
  },
  /* eslint-disable */
  computed: {
    seriesLabel() {
      let tmpLabels = [];
      this.labels.forEach((item) => {
        if (item === 'human') {
          tmpLabels.push('Call - Discador');
        } else if (item === 'manual_human') {
          tmpLabels.push('Call - Individual');
        } else if (item === null) {
          tmpLabels.push('Sin canal');
        } else {
          tmpLabels.push(`${item.charAt(0).toUpperCase()}${item.slice(1)}`);
        }
      });
      return tmpLabels;
    },
  },
  methods: {
    getReport() {
      this.axios.get(`daily_payments/by_channel?${qs.stringify(this.filters)}`).then((response) => {
        this.totalAmount = this.sumArr(response.data, 'amount');
        this.totalNotifications = this.sumArr(response.data, 'total');
        this.labels = response.data.map(report => report.channel);
        this.series = response.data.map(report => report.total);
        for (let i = 0; i < 5; i++) {
          if (this.series[i] === undefined) {
            this.series.push(0);
          }
        }
        this.seriesChart = this.series;
      });
    },
    getChart() {
      const maxValue = this.graphicMaxValue(this.seriesChart);
      new Chartist.Bar(`#payment_chart`, { // eslint-disable-line
        labels: this.seriesLabel,
        series: this.seriesChart,
      }, {
        distributeSeries: true,
        height: '55vh',
        plugins: [
          Chartist.plugins.ctBarLabels(),
        ],
        axisY: {
          type: Chartist.FixedScaleAxis,
          high: maxValue + this.graphicScale(maxValue),
          ticks: this.graphicTicks(maxValue),
          offset: 40,
        },
        axisX: {
          offset: 40,
        },
      });
    },
    sumArr(arr, key) {
      let total = 0;
      arr.forEach((item) => {
        total += parseInt(item[key]);
      });
      return total;
    },
    generateReport() {
      EventBus.$emit('startListenEvent');
      const data = {
        filters: this.filters,
        functionName: 'payments',
      };
      this.axios.post('/reports', data).then(() => {
        EventBus.$emit('infoModal',
          'Se esta generando su archivo, se le informara cuando este listo el reporte, por favor espere.',
          'fas fa-check-double');
      });
    },
    filter() {
      EventBus.$emit(this.sidebarBus.open);
    },
    getDueDays() {
      this.axios.get(`/daily_payments/group_by?column=due_day&date=${this.filters.date}&type=${this.filters.type}&channel=${this.filters.channel}`).then((resp) => {
        this.dueDays = resp.data;
        this.dueDays.unshift({
          text: 'Vencimientos',
          value: '',
        });
      });
    },
    getAgencies() {
      this.axios.get(`/daily_payments/group_by?column=agency&date=${this.filters.date}&type=${this.filters.type}&channel=${this.filters.channel}`).then((resp) => {
        this.agencies = resp.data;
        this.agencies.unshift({
          text: 'Agencias',
          value: '',
        });
      });
    },
    getPursesList() {
      this.axios.get(`/daily_payments/group_by?column=portfolio_type&date=${this.filters.date}&type=${this.filters.type}&channel=${this.filters.channel}`).then((resp) => {
        this.pursesList = resp.data;
        this.pursesList.unshift({
          text: 'Carteras',
          value: '',
        });
      });
    },
  },
  /* eslint-enable */
  watch: {
    seriesChart() {
      this.getChart();
    },
    filters: {
      handler() {
        this.getReport();
      },
      deep: true,
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/panel/payment_smy/PaymentReport.vue